import { Typography } from "@material-ui/core"

const Social = (props) => {

  return ( <>
    <Typography>
      Of course! It’s your song, so feel free to share it on Instagram, TikTok, YouTube, or anywhere else you want to show it off. Just tag us if you do—we’d love to see it in the wild! Keep in mind that while you can post and share it freely, we still retain the rights to the song, so if you’re planning to use it for commercial purposes, reach out to us about licensing.  
    </Typography>
  </> )
}

export default Social
